import React from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import Video from "../project/Posts/Video"

const PostPage = ({ data }) => {
  const postdata = data.wordpressPost
  return (
    <Layout>
      <Seo title={postdata.title} description={postdata.excerpt} slug={postdata.slug} />
      <Video post={postdata} single />
    </Layout>
  )
}

PostPage.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
}

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPost(
      id: {
        eq: $id
      }
    ) {
      id
      slug
      title
      excerpt
      raw
      acf{
        imagen
        video
        creditos
      }
    }
  }
`

export default PostPage

